module.exports = __webpack_public_path__ + "media/images/icon__plus@2x-8b27de31726760c9ddf5d4190fcb4f5d.png";